import { useSelector, useDispatch } from "react-redux";
import { Container, Stack, Typography } from "@mui/material";

import AutocompleteWithTags from "components/AutocompleteWithTags";

import { setPopulationServed, selectPopulationsServed } from "../slice";

const populationOptions = [
    "Young Children (0-6)",
    "Children & Youth (7-18)",
    "Young Adults (18-29)",
    "Seniors & Older Adults",
    "Women",
    "Men",
    "2SLGBTQ+ Communities",
    "Indigenous Peoples",
    "Black Communities",
    "Other Racialized Communities",
    "People with Disabilities",
    "Intellectual & Developmental Disabilities",
    "Mental Health",
    "Substance Use & Recovery",
    "People with a Specific Health Condition",
    "Caregivers",
    "Low-Income Individuals & Families",
    "Homelessness & Housing Insecurity",
    "Food Insecurity",
    "Unemployed & Job Seekers",
    "Single-Parent Families",
    "Children in Care & Foster Youth",
    "Immigrants & Newcomers",
    "Refugees & Asylum Seekers",
    "Veterans & Military Families",
    "First Responders & Frontline Workers",
    "Survivors of Violence & Abuse",
    "Justice-Involved People",
    "Residential School & Institutional Abuse Survivors",
    "Rural Communities",
    "Remote & Northern Communities",
    "Urban & Inner-City Communities",
    "Disaster-Affected Communities",
    "Communities Facing Environmental Harm",
    "K-12 Students",
    "Post-Secondary & Trades Students",
    "Adult Learners & Literacy",
    "Artists & Creative Workers",
    "Christian Communities",
    "Jewish Communities",
    "Muslim Communities",
    "Other Faith Communities",
    "Companion & Domestic Animals",
    "Wildlife & Species at Risk",
    "Land, Water & Ecosystems",
];

const populationOptionsList = populationOptions.map((label) => ({ label }));

const PopulationsServedStep = () => {
    const dispatch = useDispatch();
    const populationsServed = useSelector(selectPopulationsServed);

    const handleChange = (newValue) => {
        dispatch(setPopulationServed(newValue));
    };

    return (
        <Container maxWidth="sm" sx={{ mt: 2 }}>
            <Stack alignItems="center" gap={1.5}>
                <Typography fontWeight="500" color="text.mediumDark">
                    Select the populations your organization serves
                </Typography>

                <AutocompleteWithTags
                    placeholder="Search populations..."
                    list={populationOptionsList}
                    selectedValues={populationsServed}
                    onChange={handleChange}
                />
            </Stack>
        </Container>
    );
};

export default PopulationsServedStep;
